// Light or dark theme, per person and per browser (D78). Light is the default; the choice is
// remembered in localStorage. Printing always uses the light theme (POs, RFQs, delivery notes).
export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'procure.theme';

export function initialTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    // Storage can be blocked (private mode, policy): light is the safe default.
    return 'light';
  }
}

function set(theme: Theme): void {
  if (theme === 'dark') document.documentElement.dataset.theme = 'dark';
  else delete document.documentElement.dataset.theme;
}

export function applyTheme(theme: Theme, remember = true): void {
  set(theme);
  if (!remember) return;
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Not remembering the choice is acceptable.
  }
}

let printHooked = false;

/** Applies the saved theme and makes printing use the light theme. Call once at start. */
export function startTheme(): void {
  set(initialTheme());
  if (printHooked) return;
  printHooked = true;
  window.addEventListener('beforeprint', () => set('light'));
  window.addEventListener('afterprint', () => set(initialTheme()));
}
